import { useAppointmentTypesQuery, VisitType } from "~/services";

export const useGetAppointmentDuration = (visitType: VisitType) => {
  const { data: appointmentTypes, isLoading } = useAppointmentTypesQuery();
  const duration = appointmentTypes?.find(
    (type) => type.slug === visitType,
  )?.duration;
  return {
    duration,
    isLoading,
  };
};
